import { resolveEndpoint } from '../../resolveEndpoint';
import type { IEndpoint } from '../../types';

import { casinoConfigParserJson, xml2CasinoConfig } from './parsers';
import { CasinoConfigType, CasinoConfigVersion, ICasinoConfigJson } from './types';

export const casinoConfigEndpoint: IEndpoint<CasinoConfigType, undefined> = resolveEndpoint('casinoConfig', {
  [CasinoConfigVersion.JSP]: {
    url: '/cgibin/casinoconfig.jsp',
    parser: (rawResponse): CasinoConfigType => xml2CasinoConfig(rawResponse as string),
    format: 'text',
  },
  [CasinoConfigVersion.JSON]: {
    url: '/api/config/casino',
    parser: (rawResponse): CasinoConfigType => casinoConfigParserJson(rawResponse as ICasinoConfigJson),
    format: 'json',
  },
});
